import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/access';
import { AnnouncementsPage } from '@/features/announcement/list-page';
import { PlatformWorkspace } from '@/features/tenant/platform-workspace';

export const Route = createFileRoute(
  '/_authenticated/operations/announcements',
)({
  beforeLoad: ({ context, location }) =>
    requirePermission(context.queryClient, location.href, 'announcements:read'),
  component: AnnouncementsRoute,
});

function AnnouncementsRoute() {
  const { session } = Route.useRouteContext();
  return (
    <PlatformWorkspace session={session}>
      <AnnouncementsPage />
    </PlatformWorkspace>
  );
}
